import { useFormSelector } from "../../../redux/formStoreHooks"
import { RenderMedia } from "@fusion-advantage/backcompat"
import L2Surface, { L2SurfaceProps } from "../l2/L2Surface"
import { L4PrintBound } from "./L4Print"

interface L4SurfaceProps extends L2SurfaceProps {
	xpath: string
	printBound?: boolean
}

const L4Surface = (props: L4SurfaceProps) => {
	const media = useFormSelector(state => state.render.media)
	const content = <L2Surface {...props} print={media === RenderMedia.Print} />
	if(props.printBound === false) {
		return content
	}
	return (
		<L4PrintBound xpath={props.xpath}>
			{content}
		</L4PrintBound>
	)
}

export default L4Surface
